import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface TrendIndicatorProps {
  value: number; // percentage change
  label?: string;
  showValue?: boolean;
}

export default function TrendIndicator({ value, label, showValue = true }: TrendIndicatorProps) {
  const isPositive = value > 0;
  const isNeutral = value === 0;
  
  const colorClass = isPositive
    ? 'text-emerald-500 dark:text-emerald-300'
    : isNeutral
      ? 'text-glass-text-2'
      : 'text-rose-500 dark:text-rose-300';
  const bgClass = isPositive
    ? 'bg-emerald-500/15 border border-emerald-500/30'
    : isNeutral
      ? 'bg-glass-3 border border-glass'
      : 'bg-rose-500/15 border border-rose-500/30';
  
  const Icon = isPositive ? TrendingUp : isNeutral ? Minus : TrendingDown;
  
  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${colorClass} ${bgClass}`}>
      <Icon className="w-3 h-3" />
      {showValue && <span>{Math.abs(value)}%</span>}
      {label && <span className="text-[10px] opacity-75">{label}</span>}
    </div>
  );
}

